import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useAuth } from "../../../shared/contexts/auth/useAuth.ts";
import { useQueries } from "../../../shared/hooks/useQueries.ts";

// oxlint-disable-next-line @typescript-eslint/explicit-function-return-type
export function useMediaActions() {
  const { api } = useAuth();

  const queryClient = useQueryClient();
  const { getMediaTaxonomiesQueryOptions } = useQueries();
  const invalidateTaxonomies = async (): Promise<void> => {
    const taxonomiesQueryOptions = getMediaTaxonomiesQueryOptions();

    await queryClient.invalidateQueries({
      queryKey: taxonomiesQueryOptions.groupQueryKey,
    });
  };

  const createTaxonomy = useMutation({
    mutationFn: api.media.createTaxonomy,
    onSuccess: invalidateTaxonomies,
  });

  return { createTaxonomy };
}
